module.exports = __webpack_public_path__ + "static/media/All_one_Logo_200.3904ba75.png";